import { render } from "./ManualsAndVideos.vue?vue&type=template&id=74bbdc14"
import script from "./ManualsAndVideos.vue?vue&type=script&lang=js"
export * from "./ManualsAndVideos.vue?vue&type=script&lang=js"

import "./ManualsAndVideos.vue?vue&type=style&index=0&id=74bbdc14&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__